import { AppsLink } from '@wellesley/router'
import { Check } from 'lucide-react'
import { Button } from '@wellesley/ui'

export const ForgotPasswordLogin = () => (
  <div className="inline-flex w-[450px] flex-col items-center justify-start gap-m overflow-hidden rounded-lg bg-white">
    <div className="flex w-full flex-col items-center justify-start bg-white px-m pb-m pt-xxl">
      <div className="flex size-l items-center justify-center">
        <div className="flex size-l items-center justify-center overflow-hidden">
          <Check className="text-green-500" size={48} strokeWidth={2.5} />
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-start gap-s">
        <div className="text-black/90 text-2xl font-semibold leading-8">
          You&apos;re all set
        </div>
        <div className="w-full text-center text-base font-medium leading-5 text-gray-900">
          You&apos;ve successfully changed your password
        </div>
      </div>
    </div>
    <div className="flex w-full items-center justify-end bg-white px-m pb-m">
      <Button
        asChild
        variant="primary"
        size="m"
        className="h-m flex-1 rounded-m"
      >
        <AppsLink to="/signin">Sign in</AppsLink>
      </Button>
    </div>
  </div>
)
